/**
 * The deck screen's tap-only «Карточки {n} | Тексты {n}» switch (handoff §8, §19.6).
 *
 * It is a tap target and nothing more: no pointer handlers, no sideways scroll.
 * Swipe navigation is off inside a deck and the deck has its own horizontal
 * gestures, so a swipe between the two would compete with them (ADR-115
 * Decision 11). On the phone it sits in the scrolling content under the
 * daily-queue row (never in the top strip, ADR-067 Decision 1); on desktop it is
 * the first row of the list column's head.
 */
import { useLocale } from '../../i18n/context'
import type { DeckSegment } from '../../stores/deckSegment'
import { Segmented } from './ui'

interface Props {
  cardCount: number
  textCount: number
  segment: DeckSegment
  onSelect: (segment: DeckSegment) => void
  /** The list column's 236 px switch with 30 px segments (§19.6); otherwise the phone's full-width one. */
  compact?: boolean
}

export default function DeckSegmentSwitch({ cardCount, textCount, segment, onSelect, compact = false }: Props) {
  const { tr } = useLocale()
  const t = tr.deckTexts
  return (
    <Segmented<DeckSegment>
      label={t.switchLabel}
      value={segment}
      onChange={onSelect}
      height={compact ? 36 : 44}
      inset={compact ? 3 : 4}
      width={compact ? 236 : undefined}
      options={[
        { id: 'cards', label: `${t.segCards} ${cardCount}`, testId: 'deck-seg-cards' },
        { id: 'texts', label: `${t.segTexts} ${textCount}`, testId: 'deck-seg-texts' },
      ]}
    />
  )
}
